import {flow, get} from '@yandex-delivery/utils'
import {useCallback, useMemo} from 'react'

import type {PaymentCardProps} from '../components/PaymentCard/types'
import {useSegments} from './useSegments'

export const useGetBody = (): PaymentCardProps['getBody'] => {
  const segments = useSegments()

  const getSegmentNameByProductName = useCallback(
    (productName?: string) => (productName && productName in segments ? segments[productName] : 'other'),
    [segments],
  )
  const getSegment = useMemo(
    () => flow(get('destinationPoints[0].parcels[0].products[0].name'), getSegmentNameByProductName),
    [getSegmentNameByProductName],
  )

  return useCallback(
    (state: unknown) => ({
      segment: getSegment(state),
    }),
    [getSegment],
  )
}
